import InputField from 'components/fields/InputField';
import { useEffect, useState } from 'react';

const WorkExperience = ({
  studentData,
  handleAcademicRecordChange,
  addAcademicRecord,
  handleWorkExperienceChange,
  addWorkExperience,
  handleInputChange,
  removeAcademicRecord,
  removeWorkExperience,
  setDisable,
  setStudentData,
}) => {
  const [errors, setErrors] = useState({
    parentInfo: {},
    academicRecords: [],
    workExperience: [],
    jobLocations: [],
  });

  const [newStream, setNewStream] = useState('');
  const [newIndex, setNewIndex] = useState('');
  const cities = [
    'Mumbai',
    'Delhi',
    'Bangalore',
    'Hyderabad',
    'Chennai',
    'Navi Mumbai',
    'Pune',
    'Ahmedabad',
    'Surat',
    'Lucknow',
    'Noida',
  ].sort();

  const getDefaultLevel = (index) => {
    switch (index) {
      case 0:
        return 'SSC';
      case 1:
        return '';
      // return 'HSC';
      case 2:
        return 'Graduation';
      case 3:
        return 'Post Graduation';
      default:
        return '';
    }
  };

  const getAvailableOptions = (index, previousLevel) => {
    switch (index) {
      case 0:
        return ['SSC'];
      case 1:
        return ['HSC', 'Diploma'];
      case 2:
        return ['Graduation'];
      case 3:
        return ['Post Graduation'];
      default:
        return [];
    }
  };

  useEffect(() => {
    const updatedRecords = studentData.academicRecords.map((record, index) => {
      if (index < 4 && !record.level) {
        // Create a synthetic event to work with the existing handler
        const syntheticEvent = {
          target: {
            id: `level-${index}`,
            value: getDefaultLevel(index),
          },
        };
        handleAcademicRecordChange(index, syntheticEvent);
        return { ...record, level: getDefaultLevel(index) };
      }
      return record;
    });

    if (
      JSON.stringify(updatedRecords) !==
      JSON.stringify(studentData.academicRecords)
    ) {
      setStudentData((prevData) => ({
        ...prevData,
        academicRecords: updatedRecords,
      }));
    }
  }, [studentData.academicRecords.length]);
  const getStreamOptions = (level) => {
    switch (level) {
      case 'HSC':
        return ['Science', 'Commerce', 'Arts'];
      case 'Diploma':
        return [
          'Computer Engineering',
          'IT Engineering',
          'Civil Engineering',
          'Mechanical Engineering',
          'Electronics Engineering',
          'Electrical Engineering',
          'Electronics and Telecommunication',
          'Production Engineering',
          'Automobile Engineering',
          'Chemical Engineering',
          'Instrumentation Engineering',
          'Plastic Engineering',
          'Textile Engineering',
          'Printing Technology',
          'Medical Laboratory Technology',
          'Hotel Management and Catering Technology',
        ];
      case 'Graduation':
        return [
          'BE Computer Engineering',
          'BE IT',
          'BE Electronics',
          'BE Mechanical',
          'BE Civil Engineering',
          'BE Electrical Engineering',
          'BE Electronics and Telecommunication',
          'BE Instrumentation',
          'BE Environmental Engineering',
          'BTech Computer Science',
          'BTech Information Technology',
          'BTech Data Science',
          'BTech Artificial Intelligence',
          'BTech Cybersecurity',
          'BTech Mechanical Engineering',
          'BTech Civil Engineering',
          'BTech Electrical Engineering',

          // Commerce Fields
          'BCom Accounting',
          'BCom Finance',
          'BCom Marketing',
          'BCom Economics',
          'BCom Business Analytics',
          'BCom Taxation',

          // Science Fields
          'BSc Mathematics',
          'BSc Physics',
          'BSc Chemistry',
          'BSc Biology',
          'BSc Computer Science',
          'BSc Information Technology',
          'BSc Biotechnology',
          'BSc Microbiology',
          'BSc Environmental Science',
          'BSc Agriculture',
          'BSc Zoology',
          'BSc Botany',
          'BSc Nursing',
          'BSc Data Science',
          'BSc Forensic Science',

          // Arts Fields
          'BA English',
          'BA History',
          'BA Sociology',
          'BA Political Science',
          'BA Psychology',
          'BA Economics',
          'BA Philosophy',
          'BA Education',
          'BA Journalism and Mass Communication',
          'BA Fine Arts',

          // Management and Business
          'BBA General',
          'BBA Finance',
          'BBA Marketing',
          'BBA Human Resource Management',
          'BBA International Business',
          'BBA Business Analytics',
          'BBA Entrepreneurship',

          // Professional Fields
          'BCA Computer Applications',
          'BPharm Pharmacy',
          'BArch Architecture',
          'BDS Dental Surgery',
          'BPT Physiotherapy',
          'LLB Law',
          'BHM Hotel Management',
          'BVSc Veterinary Science',
          'BFA Fine Arts',
          'BDes Design',

          // Specialized Fields
          'BStat Statistics',
          'BASLP Audiology and Speech-Language Pathology',
          'BS Biomedical Engineering',
          'BS Aerospace Engineering',
          'BS Artificial Intelligence',
        ];
      case 'Post Graduation':
        return [
          'ME Computer Engineering',
          'ME IT',
          'ME Electronics',
          'ME Mechanical',
          'ME Civil Engineering',
          'ME Electrical Engineering',
          'ME Electronics and Telecommunication',
          'ME Instrumentation',
          'ME Environmental Engineering',
          'ME Software Engineering',
          'ME Structural Engineering',
          'MTech Computer Science',
          'MTech Information Technology',
          'MTech Data Science',
          'MTech Artificial Intelligence',
          'MTech Cybersecurity',
          'MTech Mechanical Engineering',
          'MTech Civil Engineering',
          'MTech Electrical Engineering',

          // Commerce Fields
          'MCom Accounting',
          'MCom Finance',
          'MCom Marketing',
          'MCom Economics',
          'MCom Business Analytics',

          // Science Fields
          'MSc Mathematics',
          'MSc Physics',
          'MSc Chemistry',
          'MSc Biology',
          'MSc Biotechnology',
          'MSc Computer Science',
          'MSc Data Science',
          'MSc Information Technology',
          'MSc Microbiology',
          'MSc Environmental Science',
          'MSc Agriculture',
          'MSc Zoology',
          'MSc Botany',
          'MSc Nursing',

          // Arts Fields
          'MA English',
          'MA History',
          'MA Sociology',
          'MA Political Science',
          'MA Psychology',
          'MA Economics',
          'MA Philosophy',
          'MA Education',

          // Professional Fields
          'MBA Finance',
          'MBA Marketing',
          'MBA Human Resource Management',
          'MBA Operations Management',
          'MBA IT Management',
          'MBA International Business',
          'MBA Entrepreneurship',
          'MBA Business Analytics',
          'MBA Supply Chain Management',
          'MBA Healthcare Management',

          // Other Fields
          'MCA Computer Applications',
          'MEd Education',
          'LLM Corporate Law',
          'LLM International Law',
          'MPharm Pharmacy',
          'MDS Dental Surgery',
          'MPT Physiotherapy',
          'MDes Design',
          'MFA Fine Arts',
          'MHM Hotel Management',
          'MVSc Veterinary Science',
          'MS Software Systems',
          'MS Biomedical Engineering',
          'MS Aerospace Engineering',
          'MS Artificial Intelligence',
        ];
      default:
        return [];
    }
  };

  const addJobLocation = (e) => {
    const selectedCity = e.target.value;
    if (
      selectedCity &&
      !studentData.jobLocationPreference.includes(selectedCity)
    ) {
      setStudentData((prevData) => ({
        ...prevData,
        jobLocationPreference: [
          ...prevData.jobLocationPreference,
          selectedCity,
        ],
      }));
    }
  };

  const removeJobLocation = (locationToRemove) => {
    setStudentData((prevData) => ({
      ...prevData,
      jobLocationPreference: prevData.jobLocationPreference.filter(
        (location) => location !== locationToRemove
      ),
    }));
  };

  const validateParentInfo = () => {
    const parentErrors = {};
    if (!studentData.parentName.trim())
      parentErrors.parentName = 'Parent name is required';

    if (!studentData.ParentContactNo.trim())
      parentErrors.ParentContactNo = 'Parent contact number is required';
    else if (!/^\d{10}$/.test(studentData.ParentContactNo))
      parentErrors.ParentContactNo = 'Invalid contact number';

    return parentErrors;
  };
  const validateAcademicRecords = () => {
    return studentData.academicRecords.map((record, index) => {
      const recordErrors = {};
      if (!record.level?.trim())
        recordErrors.level = 'Education level is required';
      if (
        !record.stream &&
        ['HSC', 'Graduation', 'Post Graduation'].includes(record.level)
      )
        recordErrors.stream = 'Stream is required';
      if (!record.institutionName.trim())
        recordErrors.institutionName = 'Institution name is required';
      if (!record.board.trim())
        recordErrors.board = 'Board/University is required';
      if (!record.yearOfCompletion.trim())
        recordErrors.yearOfCompletion = 'Completion year is required';
      if (!record.percentage.trim() && !record.gpa.trim())
        recordErrors.performance = 'Either percentage or GPA is required';
      return recordErrors;
    });
  };
  const validateWorkExperience = () => {
    if (
      !studentData.workExperience ||
      !Array.isArray(studentData.workExperience)
    ) {
      return [];
    }

    return studentData.workExperience.map((experience) => {
      const experienceErrors = {};

      if (
        !experience.companyName ||
        typeof experience.companyName !== 'string' ||
        !experience.companyName.trim()
      ) {
        experienceErrors.companyName = 'Company name is required';
      }

      if (
        !experience.position ||
        typeof experience.position !== 'string' ||
        !experience.position.trim()
      ) {
        experienceErrors.position = 'Position is required';
      }

      if (!experience.startDate) {
        experienceErrors.startDate = 'Start date is required';
      }

      if (!experience.endDate) {
        experienceErrors.endDate = 'End date is required';
      } else if (
        experience.startDate &&
        experience.endDate &&
        new Date(experience.endDate) <= new Date(experience.startDate)
      ) {
        experienceErrors.endDate = 'End date must be after start date';
      }

      if (
        !experience.responsibilities ||
        typeof experience.responsibilities !== 'string' ||
        !experience.responsibilities.trim()
      ) {
        experienceErrors.responsibilities = 'Responsibilities are required';
      }

      if (
        !experience.skills ||
        typeof experience.skills !== 'string' ||
        !experience.skills.trim()
      ) {
        experienceErrors.skills = 'At least one skill is required';
      }

      return experienceErrors;
    });
  };
  const validateJobLocations = () => {
    const locationErrors = {};
    if (studentData.jobLocationPreference.length === 0)
      locationErrors.locations = 'At least one job location is required';

    return locationErrors;
  };

  useEffect(() => {
    const parentInfoErrors = validateParentInfo();
    const academicRecordErrors = validateAcademicRecords();
    const workExperienceErrors = validateWorkExperience();
    const jobLocationErrors = validateJobLocations();

    const newErrors = {
      parentInfo: parentInfoErrors,
      academicRecords: academicRecordErrors,
      workExperience: workExperienceErrors,
      jobLocations: jobLocationErrors,
    };

    setErrors(newErrors);

    const hasErrors =
      Object.keys(parentInfoErrors).length > 0 ||
      academicRecordErrors.some((record) => Object.keys(record).length > 0) ||
      workExperienceErrors.some((exp) => Object.keys(exp).length > 0) ||
      Object.keys(jobLocationErrors).length > 0;

    setDisable(hasErrors);
  }, [studentData, setDisable]);

  const renderFieldError = (errorMessage) =>
    errorMessage && (
      <div className="mt-1 text-sm text-red-500">{errorMessage}</div>
    );
  const handleStreamChange = (index, e) => {
    const value = e.target.value;
    const updatedRecords = [...studentData.academicRecords];
    updatedRecords[index].stream = value;

    // Clear newStream if not "other"
    if (value !== 'other') {
      updatedRecords[index].newStream = '';
    }
    // setAcademicRecords(updatedRecords);
  };

  const handleNewStreamChange = (index, e) => {
    setNewStream(e.target.value);
    setNewIndex(index);
    // handleAcademicRecordChange(index, e)
  };
  const titleCase = (str) => {
    return str
      .trim()
      .toLowerCase()
      .replace(/\s+/g, ' ')
      .replace(/\b\w/g, (char) => char.toUpperCase());
  };

  const handleAddAcademicRecord = () => {
    if (newStream) {
      const formattedStream = titleCase(newStream); // Capitalize each word
      handleAcademicRecordChange(newIndex, {
        target: { id: 'stream-1', value: formattedStream },
      });
      setNewStream('');
      setNewIndex('');
    }
    addAcademicRecord();
  };

  return (
    <div className="h-full w-full rounded-[20px] px-3 pt-7 md:px-8">
      <h4 className="pt-[5px] text-xl font-bold text-navy-700 dark:text-white">
        Parent Info
      </h4>
      <div className="mt-5 grid grid-cols-1 gap-3 md:grid-cols-2">
        <div>
          <InputField
            extra="mb-3"
            label="Parent Name / Guardian Name"
            placeholder="Enter Parent Name or Guardian Name"
            id="parentName"
            type="text"
            onChange={handleInputChange}
            value={studentData.parentName}
            maxLength={40}
          />
          {renderFieldError(errors.parentInfo.parentName)}
        </div>
        <div>
          <InputField
            extra="mb-3"
            label="Contact No"
            placeholder="Enter Parent/Guardian No"
            id="ParentContactNo"
            type="text"
            onChange={handleInputChange}
            value={studentData.ParentContactNo}
            maxLength={10}
          />
          {renderFieldError(errors.parentInfo.ParentContactNo)}
        </div>
      </div>

      <h4 className="mb-6 text-xl font-bold text-navy-700 dark:text-white">
        Education and Work Experience
      </h4>

      {/* Academic Records Section */}
      <div className="mb-8">
        <h5 className="mb-4 text-lg font-semibold text-navy-700 dark:text-white">
          Academic Records
        </h5>
        {studentData.academicRecords.map((record, index) => (
          <div
            key={index}
            className="mb-6 rounded-lg border border-gray-200 p-4 dark:border-white/10"
          >
            <h6 className="text-md mb-3 font-medium">
              {getDefaultLevel(index)}
            </h6>
            <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
              <div>
                <label className="mb-2 block p-0.5 text-sm font-medium text-navy-700 dark:text-white">
                  Level
                </label>
                <select
                  id={`level-${index}`}
                  onChange={(e) => handleAcademicRecordChange(index, e)}
                  value={record.level || getDefaultLevel(index)}
                  disabled={index === 0} // Only disable SSC
                  className="w-full rounded-xl border border-gray-200 p-3.5 text-sm outline-none dark:border-white/10 dark:bg-navy-800 dark:text-white"
                >
                  <option value="">Select Level</option>
                  {getAvailableOptions(
                    index,
                    index > 0
                      ? studentData.academicRecords[index - 1]?.level
                      : null
                  ).map((option) => (
                    <option key={option} value={option}>
                      {option}
                    </option>
                  ))}
                </select>
                {renderFieldError(errors.academicRecords[index]?.level)}
              </div>
              {record.level &&
                ['HSC', 'Diploma', 'Graduation', 'Post Graduation'].includes(
                  record.level
                ) && (
                  <div>
                    <label className="mb-2 block p-0.5 text-sm font-medium text-navy-700 dark:text-white">
                      Stream
                    </label>
                    <select
                      id={`stream-${index}`}
                      onChange={(e) => handleAcademicRecordChange(index, e)}
                      value={record.stream || ''}
                      className="w-full rounded-xl border border-gray-200 p-3.5 text-sm outline-none dark:border-white/10 dark:bg-navy-800 dark:text-white"
                    >
                      <option value="">Select Stream</option>
                      <option value="other">
                        Click here to Add New Stream
                      </option>
                      {getStreamOptions(record.level).map((stream) => (
                        <option key={stream} value={stream}>
                          {stream}
                        </option>
                      ))}
                    </select>
                    {record.stream === 'other' && (
                      <input
                        id={`stream-${index}other`}
                        type="text"
                        placeholder="Enter new stream"
                        onChange={(e) => handleNewStreamChange(index, e)}
                        className="mt-2 w-full rounded-xl border border-gray-200 p-3.5 text-sm outline-none dark:border-white/10 dark:bg-navy-800 dark:text-white"
                      />
                    )}
                    {renderFieldError(errors.academicRecords[index]?.stream)}
                  </div>
                )}
              <div>
                <InputField
                  label="Institution Name"
                  placeholder="Enter Institution Name"
                  id={`institutionName-${index}`}
                  onChange={(e) => handleAcademicRecordChange(index, e)}
                  value={record.institutionName}
                  maxLength={70}
                />
                {renderFieldError(
                  errors.academicRecords[index]?.institutionName
                )}
              </div>
              <div>
                <InputField
                  label="Board/University"
                  placeholder="Enter Board or University"
                  id={`board-${index}`}
                  onChange={(e) => handleAcademicRecordChange(index, e)}
                  value={record.board}
                  maxLength={70}
                />
                {renderFieldError(errors.academicRecords[index]?.board)}
              </div>
              <div>
                <InputField
                  label="Year of Completion"
                  placeholder="Enter Year of Completion"
                  id={`yearOfCompletion-${index}`}
                  type="text"
                  onChange={(e) => handleAcademicRecordChange(index, e)}
                  value={record.yearOfCompletion}
                />
                {renderFieldError(
                  errors.academicRecords[index]?.yearOfCompletion
                )}
              </div>

              <InputField
                label="Percentage"
                placeholder="Enter Percentage"
                id={`percentage-${index}`}
                type="text"
                step="0.01"
                min="0"
                max="100"
                onChange={(e) => {
                  const value = e.target.value;
                  if (/^\d*\.?\d*$/.test(value)) {
                    handleAcademicRecordChange(index, e);
                  }
                }}
                value={record.percentage}
              />
              <InputField
                label="GPA (Optional)"
                placeholder="Enter GPA"
                id={`gpa-${index}`}
                type="text"
                maxLength={10}
                onChange={(e) => {
                  handleAcademicRecordChange(index, e); // no filtering at all
                }}
                value={record.gpa ?? ''}
              />
              {renderFieldError(errors.academicRecords[index]?.performance)}
            </div>
            {/* Remove Academic Record Button */}
            <button
              onClick={() => removeAcademicRecord(index)}
              className="mt-2 text-sm text-red-600 hover:text-red-800"
            >
              Remove Record
            </button>
          </div>
        ))}
        <button
          onClick={handleAddAcademicRecord}
          className="mt-2 rounded-lg bg-brand-500 px-4 py-2 text-white hover:bg-brand-600"
        >
          Add Academic Record
        </button>
      </div>

      {/* Work Experience Section */}
      <div className="mt-8">
        <h5 className="mb-4 text-lg font-semibold text-navy-700 dark:text-white">
          Work Experience
        </h5>
        {studentData.workExperience.map((experience, index) => (
          <div
            key={index}
            className="mb-6 rounded-lg border border-gray-200 p-4 dark:border-white/10"
          >
            <h6 className="text-md mb-3 font-medium">Experience {index + 1}</h6>
            <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
              <div>
                <InputField
                  label="Company Name"
                  placeholder="Enter Company Name"
                  id={`companyName-${index}`}
                  onChange={(e) => handleWorkExperienceChange(index, e)}
                  value={experience.companyName}
                  maxLength={70}
                />
                {renderFieldError(errors.workExperience[index]?.companyName)}
              </div>

              <div>
                <InputField
                  label="Position"
                  placeholder="Enter Position"
                  id={`position-${index}`}
                  onChange={(e) => handleWorkExperienceChange(index, e)}
                  value={experience.position}
                  maxLength={70}
                />
                {renderFieldError(errors.workExperience[index]?.position)}
              </div>

              <div>
                <InputField
                  extra="mb-3 w-full"
                  label="Start Date"
                  placeholder="Select Start Date"
                  id={`startDate-${index}`}
                  type="date"
                  onChange={(e) => handleWorkExperienceChange(index, e)}
                  value={experience.startDate}
                  allowKeyboardInput={false}
                />
                {renderFieldError(errors.workExperience[index]?.startDate)}
              </div>

              <div>
                <InputField
                  label="End Date"
                  placeholder="Select End Date"
                  id={`endDate-${index}`}
                  type="date"
                  onChange={(e) => handleWorkExperienceChange(index, e)}
                  value={experience.endDate}
                  min={experience.startDate}
                  allowKeyboardInput={false}
                />
                {renderFieldError(errors.workExperience[index]?.endDate)}
              </div>

              <div className="md:col-span-2">
                <InputField
                  label="Responsibilities"
                  placeholder="Enter Responsibilities"
                  id={`responsibilities-${index}`}
                  onChange={(e) => handleWorkExperienceChange(index, e)}
                  value={experience.responsibilities}
                  maxLength={70}
                />
                {renderFieldError(
                  errors.workExperience[index]?.responsibilities
                )}
              </div>

              <div className="md:col-span-2">
                <InputField
                  label="Skills (comma-separated)"
                  placeholder="Enter Skills"
                  id={`skills-${index}`}
                  onChange={(e) => handleWorkExperienceChange(index, e)}
                  value={experience.skills}
                  maxLength={150}
                />
                {renderFieldError(errors.workExperience[index]?.skills)}
              </div>
            </div>
            {/* Remove Work Experience Button */}
            <button
              onClick={() => removeWorkExperience(index)}
              className="mt-2 text-sm text-red-600 hover:text-red-800"
            >
              Remove Experience
            </button>
          </div>
        ))}
        <button
          onClick={addWorkExperience}
          className="mt-2 rounded-lg bg-brand-500 px-4 py-2 text-white hover:bg-brand-600"
        >
          Add Work Experience
        </button>
      </div>

      <div className="mt-8">
        <h5 className="mb-4 text-lg font-semibold text-navy-700 dark:text-white">
          Job Location Preferences
        </h5>

        <div className="mb-4">
          <label className="mb-2 block text-sm font-medium text-navy-700 dark:text-white">
            Preferred Job Locations
          </label>

          <select
            onChange={addJobLocation}
            value=""
            className="w-full rounded-xl border border-gray-200 p-2.5 text-sm outline-none dark:border-white/10 dark:bg-navy-800 dark:text-white"
          >
            <option value="">Select a city</option>
            {cities.map((city) => (
              <option
                key={city}
                value={city}
                disabled={studentData.jobLocationPreference.includes(city)}
              >
                {city}
              </option>
            ))}
          </select>

          {studentData.jobLocationPreference.length > 0 && (
            <div className="mt-4 flex flex-wrap gap-2">
              {studentData.jobLocationPreference.map((location, index) => (
                <div
                  key={index}
                  className="flex items-center rounded-lg bg-gray-100 px-3 py-1 dark:bg-navy-700"
                >
                  <span className="text-sm text-navy-700 dark:text-white">
                    {location}
                  </span>
                  <button
                    onClick={() => removeJobLocation(location)}
                    className="ml-2 text-red-500 hover:text-red-800"
                  >
                    ×
                  </button>
                </div>
              ))}
            </div>
          )}

          {renderFieldError(errors?.jobLocations?.locations)}
        </div>
      </div>

      {/* Preferred Salary Section */}
      <div className="mt-8">
        <h5 className="mb-4 text-lg font-semibold text-navy-700 dark:text-white">
          Preferred Salary
        </h5>
        <div className="mb-4">
          <label className="mb-2 block text-sm font-medium text-navy-700 dark:text-white">
            Expected Salary Range
          </label>
          <select
            value={studentData.preferredSalary || 'Any Salary'}
            onChange={(e) =>
              setStudentData((prev) => ({
                ...prev,
                preferredSalary: e.target.value,
              }))
            }
            className="w-full rounded-xl border border-gray-200 p-2.5 text-sm outline-none dark:border-white/10 dark:bg-navy-800 dark:text-white"
          >
            <option value="Any Salary">Any Salary</option>
            <option value="Below 3 LPA">Below 3 LPA</option>
            <option value="Below 4 LPA">Below 4 LPA</option>
            <option value="Below 5 LPA">Below 5 LPA</option>
            <option value="More than 5 LPA">More than 5 LPA</option>
          </select>
        </div>
      </div>

      {/* <div className="mt-8">
        <h5 className="mb-4 text-lg font-semibold text-navy-700 dark:text-white">
          Job Location Preferences
        </h5>

        <div className="mb-4">
          <label className="mb-2 block text-sm font-medium text-navy-700 dark:text-white">
            Preferred Job Locations
          </label>
          <input
            type="text"
            placeholder="Enter a location"
            value={jobLocationInput}
            onChange={handleJobLocationChange}
            className="w-full rounded-xl border border-gray-200 p-2.5 text-sm outline-none dark:border-white/10 dark:bg-navy-800 dark:text-white"
          />
          {studentData.jobLocationPreference.length > 0 && (
            <div className="flex flex-wrap gap-2">
              {studentData.jobLocationPreference.map((location, index) => (
                <div key={index} className="flex items-center space-x-2">
                  <span className="text-sm text-navy-700 dark:text-white">
                    {location}
                  </span>
                  <button
                    onClick={() => removeJobLocation(location)}
                    className="text-red-500 hover:text-red-800"
                  >
                    &times;
                  </button>
                </div>
              ))}
            </div>
          )}
          <button
            onClick={addJobLocation}
            className="mt-2 rounded-lg bg-brand-500 px-4 py-2 text-white hover:bg-brand-600"
          >
            + Add job location
          </button>
          {renderFieldError(errors.jobLocations.locations)}
        </div>
      </div> */}

      {/* Error Message */}
      {/* {error && (
        <div className="mb-3 text-red-500">
          <p>{error}</p>
        </div>
      )} */}
    </div>
  );
};

export default WorkExperience;
